import { memo, useCallback, useContext } from "react";
import { SnackbarContext, SnackbarMessagePropsExt, SnackbarMessagesContext } from "./SnackbarContext";
import { SnackbarMessage } from "./SnackbarMessage";

import styles from "./style.module.scss";

const WrappedSnackbarMessage = memo<SnackbarMessagePropsExt & { messageKey: string }>((
  { messageKey, ...props }) => {

  const { remove } = useContext(SnackbarContext);
  const removeMessage = useCallback(() => remove(messageKey), [ remove, messageKey ]);

  return <SnackbarMessage removeMessage={removeMessage} {...props} />;
});

export const Snackbar = memo(() => {
  const messages = useContext(SnackbarMessagesContext);
  return (
    <div className={styles.root}>
      {
        messages.map((props) => <WrappedSnackbarMessage
          messageKey={props.key as string}
          {...props}
        />)
      }
    </div>
  );
});

